import apiEndpoints from '../../constants/ApiEndpoints';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import callApi from '../../utils/call_apis';
import Checkbox from '@mui/material/Checkbox';
import bidSchema from '../../validations/Bid'
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import React from "react";
import Snackbar from '../generals/Snackbar';
import TextField from '@mui/material/TextField';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useSearchParams } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import Link from '@mui/material/Link';

function CreateSellersGroupForm() {

  const [searchParams, setSearchParams] = useSearchParams();
  let seller_group_id = searchParams.get('seller_group_id');
  // console.log('---seller_group_id:', seller_group_id);
  let form_action = searchParams.get('form_action');
  // console.log('---form_action:', form_action);
  const navigate = useNavigate();

  const initialValues = {
    'group_name': '',
    'file': '',
    'remove_numbers': 0
  }
  const [reqPayload, setReqPayload] = React.useState(initialValues);
  const [exportFileLink, setExportFileLink] = React.useState('');
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (form_action == 'update') {
      fetchBidDetailsBidByEmp({ id: seller_group_id })
    }
  }, []);

  const [assigneeSellerGroupsIsOpen, setAssigneeSellerGroupsIsOpen] = React.useState(false);
  const [assigneeSellerGroupsOptions, setAssigneeSellerGroupsOptions] = React.useState([]);
  const assigneeSellerGroupsIsLoading = assigneeSellerGroupsIsOpen && assigneeSellerGroupsOptions.length === 0;

  const onSubmit = values => {
    // values['price_with_gst'] = reqPayload['price_with_gst'];
    // values['price_without_gst'] = reqPayload['price_without_gst'];
    // values['discount_on_mrp'] = reqPayload['discount_on_mrp'];
    // values['discount_on_ptr'] = reqPayload['discount_on_ptr'];
    // values['assign_seller_groups_arr'] = reqPayload['assign_seller_groups_arr'];
    values['remove_numbers'] = reqPayload['remove_numbers'];
    if (form_action == 'update') {
      values['action'] = 'update';
    }
    // console.log('---onSubmit--values:', values);
    submitCreateBid(values);
  }

  const formik = useFormik({
    initialValues,
    onSubmit,
    // validate,
    validationSchema: bidSchema.createSellersGroupSchema,
    validateOnChange: false
  })

  // console.log('---formik--values:', formik.values);
  // console.log('---formik--errors:', formik.errors);

  const handleCheckbox = (event) => {
    // console.log('---handleCheckbox---name:', event.target.name, '---value:', event.target.checked);
    // initialValues[event.target.name] = event.target.checked
    // setReqPayload({ ...reqPayload, [event.target.name]: event.target.checked })
    // console.log('---handleCheckbox--initialValues:', initialValues);
    // console.log('---handleCheckbox--reqPayload:', reqPayload);
    formik.setFieldValue(event.target.name, event.target.checked ? 1 : 0);
  }

  const onChangeAssigneeSellerGroups = (event) => {
    // console.log('---onChangeAssigneeSellerGroups---START---')
  }

  const setAssigneeSellerGroupsValue = (event, name, value) => {
    // console.log('---setAssigneeSellerGroupsValue---name:', event.target.name, '---value:', event.target.checked);
    // initialValues[event.target.name] = event.target.checked
    // setReqPayload({ ...reqPayload, [event.target.name]: event.target.checked })
    // console.log('---handleCheckbox--initialValues:', initialValues);
    // console.log('---handleCheckbox--reqPayload:', reqPayload);
    // console.log('---setAssigneeSellerGroupsValue---name')
    // setReqPayload({ ...reqPayload, [name]: value })
    formik.setFieldValue(name, value);
  }

  const onChangeAssigneeSellerGroupsHandle = async value => {
    // this default api does not support searching but if you use google maps or some other use the value and post to get back you reslut and then set it using setAssigneeSellerGroupsOptions 
    // console.log('---onChangeAssigneeSellerGroupsHandle---', value);
    setAssigneeSellerGroupsIsOpen(true)
    let data = { q: value }
    const response = await callApi.requestGET(`/sellers-bids/emp/bid-assignee-sellers`, data, true)
    const assigneeSellerGroups = response.data.data.dataset;
    if (assigneeSellerGroups.length == 0) {
      setAssigneeSellerGroupsIsOpen(false)
    }
    setAssigneeSellerGroupsOptions(assigneeSellerGroups);
  };

  const handleBidPriceTypeChange = (event) => {
    // setValue(event.target.value);
    formik.setFieldValue('bid_price_type', event.target.value);
  };

  React.useEffect(() => {
    if (!assigneeSellerGroupsIsOpen) {
      setAssigneeSellerGroupsOptions([]);
    }
  }, [assigneeSellerGroupsIsOpen]);


  const successResponse = (response) => {
    // console.log('---successResponse--response:', response);
    dispatch(setSnackbar({
      status: 'success',
      message: response.data.message
    }))
    navigate('/emp/sellers-group-listing')
  }

  const errorResponse = (error) => {
    // console.log('---errorResponse--formik--errors---222:', error.response.data.errors);
    formik.setErrors({ ...error.response.data.errors })
    // console.log('---errorResponse--formik--errors---223:', formik.errors);
  }

  const fetchBidDetailsBidByEmp = async (data = {}) => {
    try {
      const response = await callApi.requestGET(`/sellers-bids/emp/sellers-groups-listing`, data, true)
      // console.log('---fetchBidDetailsBidByEmp---response:', response);
      let resp = response.data.data.dataset[0];
      resp['group_name'] = resp['name']
      formik.setValues(resp)
      // formik.setFieldValue('assign_seller_groups_arr', response.data.data.dataset[0]['assign_seller_groups_detials']);
    }
    catch (error) {
      // console.log('---fetchMetadataOfBidByEmp---error:', error);
      errorResponse(error)
    }
  }

  const submitCreateBid = async (data, query = {}) => {
    try {
      // console.log('---submitCreateBid--data:', data)
      const formData = new FormData();
      formData.append("group_name", data['group_name']);
      var imagefile = document.querySelector('#file');
      formData.append("file", imagefile.files[0]);
      formData.append("remove_numbers", data['remove_numbers']);
      const response = await callApi.requestFilePOST(`/sellers-bids/emp/create-or-update-sellers-group`, formData, true)
      // console.log('---submitCreateBid---response:', response);
      setExportFileLink('')
      successResponse(response)
    }
    catch (error) {
      // console.log('---submitCreateBid---error:', error);
      setExportFileLink(`${apiEndpoints.apiHost}${error.response.data.export_file_link}`)
      errorResponse(error)
    }
  }


  return (
    <div>
      <Grid container direction="row" alignItems="center" justifyContent="" >

        <Box component="form" className="tw-mb-20" onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={8}>
              <TextField disabled={form_action == 'update'} id="groupNameId" className="tw-w-full" label="Group Name" type="text" name="group_name" variant="outlined" onChange={formik.handleChange} value={formik.values.group_name} error={formik.errors.group_name ? true : false} helperText={formik.errors.group_name} required />
            </Grid>

            <Grid item xs={12} sm={6}>
              {/* <TextField id=".quantityId" className="tw-w-full" xs={12} sm={6} label="Quantity" type="number" name="quantity" variant="outlined" onChange={formik.handleChange} value={formik.values.quantity} error={formik.errors.quantity ? true : false} helperText={formik.errors.quantity} required /> */}
            </Grid>

            <Grid item xs={12} sm={8}>
              <Link component="a" href={`${apiEndpoints.s3Host}/static/templates/sellerbids_seller_group_create_or_update_upload_file_template_v2.xlsx`} >Download Template</Link><br/>
              <TextField id="file" className="tw-w-full" xs={12} sm={6} type="file" name="file" onChange={formik.handleChange} value={formik.values.file} error={formik.errors.file ? true : false} helperText={formik.errors.file} required />
              {exportFileLink && exportFileLink != '' &&
                <div>
                  Download error file, By click on <a className="tw-text-blue-500" href={exportFileLink}>link</a>
                </div>
              }
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControlLabel control={<Checkbox name="remove_numbers" value={formik.values.remove_numbers} checked={formik.values.remove_numbers} onChange={handleCheckbox} />} label="Remove Numbers" />
            </Grid>
          </Grid>

          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} className="tw-mt-10">
              <Button type="submit" variant="contained">{form_action != 'update' ? 'create' : 'update'} Sellers Group</Button>
            </Grid>
          </Grid>
        </Box>

      </Grid>

      <Snackbar />
    </div>
  );

}


export { CreateSellersGroupForm };
